module.exports = __webpack_public_path__ + "static/img/b2.1ba44e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b2.jpg
// module id = XpVh
// module chunks = 1